import { data_from_server_get, data_from_server_post } from '@/shared/http/client';

export function createModelPerfRun(payload, onSuccess, onError) {
  return data_from_server_post('model-perf-runs', payload, onSuccess, onError);
}

export function listModelPerfRuns({ clientId, llmUsecaseId, modelVersion }, onSuccess) {
  const params = new URLSearchParams({
    client_id: clientId,
    llm_usecase_id: llmUsecaseId,
  });
  if (modelVersion) {
    params.set('model_version', modelVersion);
  }
  return data_from_server_get(`model-perf-runs?${params.toString()}`, onSuccess);
}

export function getModelPerfRun(runId, onSuccess) {
  return data_from_server_get(`model-perf-runs/${runId}`, onSuccess);
}

export function getModelPerfPlatform(onSuccess) {
  return data_from_server_get('model-perf-runs/platform', onSuccess);
}
